// api.ts
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const api = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_SERVER_URL,
        credentials: 'include',
    }),
    reducerPath: "api",
    tagTypes: ["users", "Item", "Feedback", "AiInsights", "answers", "question", "shared_recordings", "feedbackToSystem", "DynamicContents", "AI_Insights", "Categories"],
    endpoints: () => ({}),
});



